import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-10 0 320 300"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M281 262h5q6-2 10-6t4-12q0-13-8-28-10-20-28-32-24-15-58-15t-57 15q-19 12-29 32-7 15-7 28 0 8 4 12t9 6h155m-149-18h-1q0-6 3-13 4-11 12-20 20-23 60.5-23.5T267 211q7 9 11 20 3 7 3 13zm74-113q16 0 27-11t11-26.5T233 67t-26.5-11T180 67t-11 26.5 11 26.5 26 11m57-37q0 23-16.5 39.5t-40 16.5-40-16.5-16.5-40T166.5 54t40-16.5 39.5 16T262 94zm-133 80q-11-4-23-5H94q-34 0-58 15-18 12-28 32-8 15-8 28 0 18 19 18h79q-4-8-4-18 0-30 20-55 7-8 16-15m-38 13q-17 26-17 57H19q0-5 3-13 4-11 11-20 20-23 59-23zm-64-84q0-23 16.5-39.5t40-16.5 40 16.5T141 103t-16.5 39.5-40 16.5-40-16.5T28 103m56-37q-15 0-26 11t-11 26.5T58 130t26.5 11 26.5-11 11-26.5T111 77 84 66"
    }, null, -1)
  ])))
}
export default { render: render }